const AUTOMAGIC_SERVER_HOST = process.env.REACT_APP_AUTOMAGIC_SERVER_HOST

/*
 *
 * New Logo Steps
 *
 */

// Step 01: About Logo

export const STEP_ABOUT_LOGO = 'STEP_ABOUT_LOGO'
export const stepAboutLogo = (formInfo) => {
  return {
    type: STEP_ABOUT_LOGO,
    payload: formInfo
  }
}

export const UPDATE_LOGO_NAME = 'UPDATE_LOGO_NAME'
export const updateLogoName = (formInfo) => {
  return {
    type: UPDATE_LOGO_NAME,
    payload: formInfo
  }
}

export const UPDATE_SLOGAN = 'UPDATE_SLOGAN'
export const updateSlogan = (formInfo) => {
  return {
    type: UPDATE_SLOGAN,
    payload: formInfo
  }
}

export const UPDATE_LOGO_DESCRIPTION = 'UPDATE_LOGO_DESCRIPTION'
export const updateLogoDescription = (formInfo) => {
  return {
    type: UPDATE_LOGO_DESCRIPTION,
    payload: formInfo
  }
}

// Step 02: Sector

export const STEP_SECTOR = 'STEP_SECTOR'
export const stepSector = (formInfo) => {
  return {
    type: STEP_SECTOR,
    payload: formInfo
  }
}

export const UPDATE_SELECTED_SECTOR = 'UPDATE_SELECTED_SECTOR'
export const updateSelectedSector = (data) => {
  return {
    type: UPDATE_SELECTED_SECTOR,
    payload: data
  }
}

export const FETCH_SECTOR = 'FETCH_SECTOR'
const _fetchSector = () => {
  return {
    type: FETCH_SECTOR
  }
}

export const FETCH_SECTOR_SUCCESS = 'FETCH_SECTOR_SUCCESS'
const _fetchSectorSuccess = (data) => {
  return {
    type: FETCH_SECTOR_SUCCESS,
    payload: data
  }
}

export const FETCH_SECTOR_FAILURE = 'FETCH_SECTOR_FAILURE'
const _fetchSectorFailure = (error) => {
  return {
    type: FETCH_SECTOR_FAILURE,
    payload: error
  }
}

export const fetchSector = () => {
  return (dispatch) => {
    dispatch(_fetchSector())

    let jwtFromStorage = localStorage.getItem('automagic_token')

    return fetch(`${ AUTOMAGIC_SERVER_HOST }/sectors/all`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`
      }
    })
    .then(response => response.json())
    .then(json => {
      dispatch(_fetchSectorSuccess(json))
    })
    .catch(error => {
      dispatch(_fetchSectorFailure(error))
    })
  }
}

// Step 02: Values

export const STEP_VALUES = 'STEP_VALUES'
export const stepValues = (formInfo) => {
  return {
    type: STEP_VALUES,
    payload: formInfo
  }
}

export const UPDATE_SELECTED_VALUES = 'UPDATE_SELECTED_VALUES'
export const updateSelectedValues = (data) => {
  return {
    type: UPDATE_SELECTED_VALUES,
    payload: data
  }
}

export const FETCH_VALUES = 'FETCH_VALUES'
const _fetchValues = () => {
  return {
    type: FETCH_VALUES
  }
}

export const FETCH_VALUES_SUCCESS = 'FETCH_VALUES_SUCCESS'
const _fetchValuesSuccess = (data) => {
  return {
    type: FETCH_VALUES_SUCCESS,
    payload: data
  }
}

export const FETCH_VALUES_FAILURE = 'FETCH_VALUES_FAILURE'
const _fetchValuesFailure = (error) => {
  return {
    type: FETCH_VALUES_FAILURE,
    payload: error
  }
}

export const fetchValues = () => {
  return (dispatch) => {
    dispatch(_fetchValues())

    let jwtFromStorage = localStorage.getItem('automagic_token')

    return fetch(`${ AUTOMAGIC_SERVER_HOST }/brand_values/all`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`
      }
    })
    .then(response => response.json())
    .then(json => {
      dispatch(_fetchValuesSuccess(json))
    })
    .catch(error => {
      dispatch(_fetchValuesFailure(error))
    })
  }
}

// Step 03: Emotions

export const STEP_EMOTIONS = 'STEP_EMOTIONS'
export const stepEmotions = (formInfo) => {
  return {
    type: STEP_EMOTIONS,
    payload: formInfo
  }
}

export const UPDATE_SELECTED_EMOTIONS = 'UPDATE_SELECTED_EMOTIONS'
export const updateSelectedEmotions = (data) => {
  return {
    type: UPDATE_SELECTED_EMOTIONS,
    payload: data
  }
}

export const FETCH_EMOTIONS = 'FETCH_EMOTIONS'
const _fetchEmotions= () => {
  return {
    type: FETCH_EMOTIONS
  }
}

export const FETCH_EMOTIONS_SUCCESS = 'FETCH_EMOTIONS_SUCCESS'
const _fetchEmotionsSuccess = (data) => {
  return {
    type: FETCH_EMOTIONS_SUCCESS,
    payload: data
  }
}

export const FETCH_EMOTIONS_FAILURE = 'FETCH_EMOTIONS_FAILURE'
const _fetchEmotionsFailure = (error) => {
  return {
    type: FETCH_EMOTIONS_FAILURE,
    payload: error
  }
}

export const fetchEmotions = () => {
  return (dispatch) => {
    dispatch(_fetchEmotions())

    let jwtFromStorage = localStorage.getItem('automagic_token')

    return fetch(`${ AUTOMAGIC_SERVER_HOST }/brand_emotions/all`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`
      }
    })
    .then(response => response.json())
    .then(json => {
      dispatch(_fetchEmotionsSuccess(json))
    })
    .catch(error => {
      dispatch(_fetchEmotionsFailure(error))
    })
  }
}

// Step X: Visual Inspiration

export const STEP_VISUAL_INSPIRATION = 'STEP_VISUAL_INSPIRATION'
export const stepVisualInspiration = (formInfo) => {
  return {
    type: STEP_VISUAL_INSPIRATION,
    payload: formInfo
  }
}

export const UPDATE_SELECTED_IMAGES = 'UPDATE_SELECTED_IMAGES'
export const updateSelectedImages = (data) => {
  return {
    type: UPDATE_SELECTED_IMAGES,
    payload: data
  }
}

export const FETCH_IMAGES = 'FETCH_IMAGES'
const _fetchImages = () => {
  return {
    type: FETCH_IMAGES
  }
}

export const FETCH_IMAGES_SUCCESS = 'FETCH_IMAGES_SUCCESS'
const _fetchImagesSuccess = (data) => {
  return {
    type: FETCH_IMAGES_SUCCESS,
    payload: data
  }
}

export const FETCH_IMAGES_FAILURE = 'FETCH_IMAGES_FAILURE'
const _fetchImagesFailure = (error) => {
  return {
    type: FETCH_IMAGES_FAILURE,
    payload: error
  }
}

export const fetchImages = (formData) => {
  return (dispatch) => {
    dispatch(_fetchImages())
    let jwtFromStorage = localStorage.getItem('automagic_token')
    let data = {
      brandValues: formData,
      threshold: 0.7
    }
    return fetch(`${ AUTOMAGIC_SERVER_HOST }/images/by/brand_values`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(json => {
      dispatch(_fetchImagesSuccess(json))
    })
    .catch(error => {
      dispatch(_fetchImagesFailure(error))
    })
  }
}

// Step X: Color Palettes

export const STEP_COLOR_PALETTES = 'STEP_COLOR_PALETTES'
export const stepColorPalettes = (formInfo) => {
  return {
    type: STEP_COLOR_PALETTES,
    payload: formInfo
  }
}

export const UPDATE_SELECTED_COLOR_PALETTES = 'UPDATE_SELECTED_COLOR_PALETTES'
export const updateSelectedColorPalettes = (data) => {
  return {
    type: UPDATE_SELECTED_COLOR_PALETTES,
    payload: data
  }
}

export const FETCH_COLOR_PALETTES = 'FETCH_COLOR_PALETTES'
const _fetchColorPalettes = () => {
  return {
    type: FETCH_COLOR_PALETTES
  }
}

export const FETCH_COLOR_PALETTES_SUCCESS = 'FETCH_COLOR_PALETTES_SUCCESS'
const _fetchColorPalettesSuccess = (data) => {
  return {
    type: FETCH_COLOR_PALETTES_SUCCESS,
    payload: data
  }
}

export const FETCH_COLOR_PALETTES_FAILURE = 'FETCH_COLOR_PALETTES_FAILURE'
const _fetchColorPalettesFailure = (error) => {
  return {
    type: FETCH_COLOR_PALETTES_FAILURE,
    payload: error
  }
}

export const fetchColorPalettes = (props) => {
  return (dispatch) => {
    dispatch(_fetchColorPalettes())
    let jwtFromStorage = localStorage.getItem('automagic_token')

    let selectedEmotions = props.userPrefs.selectedEmotions
    if (selectedEmotions.length < 1 && props.availableEmotions) {
      selectedEmotions = props.availableEmotions.map(item => item.uid)
    }
    let data = {
      brandValues: selectedEmotions,
      threshold: 0.7
    }
    return fetch(`${ AUTOMAGIC_SERVER_HOST }/color_palettes/by/brand_values`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(json => {
      dispatch(_fetchColorPalettesSuccess(json))
    })
    .catch(error => {
      dispatch(_fetchColorPalettesFailure(error))
    })
  }
}
// Step X: Typefaces Selector

export const STEP_TYPEFACES = 'STEP_TYPEFACES'
export const stepTypefaces = (formInfo) => {
  return {
    type: STEP_TYPEFACES,
    payload: formInfo
  }
}

export const STEP_TYPEFACES_SUCCESS = 'STEP_TYPEFACES_SUCCESS'
export const stepTypefacesSuccess = (formInfo) => {
  return {
    type: STEP_TYPEFACES_SUCCESS,
    payload: formInfo
  }
}


export const UPDATE_SELECTED_TYPEFACES = 'UPDATE_SELECTED_TYPEFACES'
export const updateSelectedTypefaces = (data) => {
  return {
    type: UPDATE_SELECTED_TYPEFACES,
    payload: data
  }
}

export const FETCH_TYPEFACES = 'FETCH_TYPEFACES'
const _fetchTypefaces = () => {
  return {
    type: FETCH_TYPEFACES
  }
}

export const FETCH_TYPEFACES_SUCCESS = 'FETCH_TYPEFACES_SUCCESS'
const _fetchTypefacesSuccess = (data) => {
  return {
    type: FETCH_TYPEFACES_SUCCESS,
    payload: data
  }
}

export const FETCH_TYPEFACES_FAILURE = 'FETCH_TYPEFACES_FAILURE'
const _fetchTypefacesFailure = (error) => {
  return {
    type: FETCH_TYPEFACES_FAILURE,
    payload: error
  }
}

export const fetchTypefaces = (props) => {
  return (dispatch) => {
    dispatch(_fetchTypefaces())
    let jwtFromStorage = localStorage.getItem('automagic_token')

    let selectedValues = props.userPrefs.selectedValues
    if (selectedValues.length < 1 && props.availableValues) {
      selectedValues = props.availableValues.map(item => item.uid)
    }

    let data = {
      brandValues: selectedValues,
      threshold: 0.5
    }
    return fetch(`${ AUTOMAGIC_SERVER_HOST }/typefaces/by/brand_values`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(json => {
      dispatch(_fetchTypefacesSuccess(json))
    })
    .catch(error => {
      dispatch(_fetchTypefacesFailure(error))
    })
  }
}

// Step 04: Select type

export const STEP_TYPE = 'STEP_TYPE'
export const stepType = (formInfo) => {
  return {
    type: STEP_TYPE,
    payload: formInfo
  }
}

export const UPDATE_SELECTED_TYPE = 'UPDATE_SELECTED_TYPE'
export const updateSelectedType = (data) => {
  return {
    type: UPDATE_SELECTED_TYPE,
    payload: data
  }
}

// Step 04: Select Keywords

export const STEP_KEYWORDS = 'STEP_KEYWORDS'
export const stepKeywords = (formInfo) => {
  return {
    type: STEP_KEYWORDS,
    payload: formInfo
  }
}

export const FETCH_ICONS = 'FETCH_ICONS'
const _fetchIcons = () => {
  return {
    type: FETCH_ICONS
  }
}

export const UPDATE_SELECTED_KEYWORDS = 'UPDATE_SELECTED_KEYWORDS'
export const updateSelectedKeywords = (data) => {
  return {
    type: UPDATE_SELECTED_KEYWORDS,
    payload: data
  }
}

export const FETCH_ICONS_SUCCESS = 'FETCH_ICONS_SUCCESS'
const _fetchIconsSuccess = (data) => {
  return {
    type: FETCH_ICONS_SUCCESS,
    payload: data
  }
}

export const FETCH_ICONS_FAILURE = 'FETCH_ICONS_FAILURE'
const _fetchIconsFailure = (error) => {
  return {
    type: FETCH_ICONS_FAILURE,
    payload: error
  }
}

export const requestIcons = (userData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(_fetchIcons())
      // Uncomment below to stop fetching icons at all
      // dispatch(_fetchIconsSuccess([]))
      // return resolve()

      let keywords = userData.selectedKeywords.filter(data => {
        return (!!data)
      })

      if(!keywords.length) {
        // keywords = ['3d']
        dispatch(_fetchIconsSuccess([]))
        return resolve()
      }

      if (userData.updatedPrefs) {
        // If didnt update keywords, do not fetch again
        if(!userData.updatedPrefs.keywords && keywords.length) {
          dispatch(_fetchIconsSuccess([]))
          return resolve()
        }
      }

      let jwtFromStorage = localStorage.getItem('automagic_token')
      if (!jwtFromStorage) {
        let err = new Error(`Unauthorized access on ${ AUTOMAGIC_SERVER_HOST }/icons`)
        err.status = 401
        dispatch(_fetchIconsFailure(err))
        return reject(err)
      }

      // if (userData.selectedLogoPreviews === null) {
      //   keywords.push('3d')
      //   // keywords.push('nature')
      // }

      let data = {
        keywords: keywords,
        language: userData.selectedLanguage || 'en'
      }
      return fetch(`${ AUTOMAGIC_SERVER_HOST }/icons`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${jwtFromStorage}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        let { status } = response
        if (Number(status) === 401) {
          // Token is unauthorized, fail and store status to handle it later
          let err = new Error(`Unauthorized access on ${ AUTOMAGIC_SERVER_HOST }/icons`)
          err.status = status
          dispatch(_fetchIconsFailure(err))
          return reject(err)
        }
        // TODO: use this error to display something
        if (Number(status) !== 200) {
          let err = new Error(response.statusText + ` on ${ AUTOMAGIC_SERVER_HOST }/icons`)
          err.status = status
          dispatch(_fetchIconsFailure(err))
          return reject(err)
        }
        response.json().then(json => {
          dispatch(_fetchIconsSuccess(json))
          return resolve(json)
        })
      })
      .catch(error => {
        dispatch(_fetchIconsFailure(error))
        return reject(error)
      })
    })
  }
}

// Step 05: Logo Preview

export const STEP_LOGO_PREVIEWS = 'STEP_LOGO_PREVIEWS'
export const stepLogoPreviews = (formInfo) => {
  return {
    type: STEP_LOGO_PREVIEWS,
    payload: formInfo
  }
}

export const UPDATE_SELECTED_LOGO_PREVIEWS = 'UPDATE_SELECTED_LOGO_PREVIEWS'
export const updateSelectedLogoPreviews = (data) => {
  return {
    type: UPDATE_SELECTED_LOGO_PREVIEWS,
    payload: data
  }
}

export const FETCH_LOGO_PREVIEWS = 'FETCH_LOGO_PREVIEWS'
const _fetchLogoPreviews = () => {
  return {
    type: FETCH_LOGO_PREVIEWS
  }
}

export const FETCH_LOGO_PREVIEWS_SUCCESS = 'FETCH_LOGO_PREVIEWS_SUCCESS'
const _fetchLogoPreviewsSuccess = (data) => {
  return {
    type: FETCH_LOGO_PREVIEWS_SUCCESS,
    payload: data
  }
}

export const FETCH_LOGO_PREVIEWS_FAILURE = 'FETCH_LOGO_PREVIEWS_FAILURE'
const _fetchLogoPreviewsFailure = (error) => {
  return {
    type: FETCH_LOGO_PREVIEWS_FAILURE,
    payload: error
  }
}

export const fetchLogoPreviews = (props) => {
  return (dispatch) => {
    if (!props.userPrefs) return null
    dispatch(_fetchLogoPreviews())

    let jwtFromStorage = localStorage.getItem('automagic_token')
    if (!jwtFromStorage) {
      let err = new Error(`Unauthorized access on ${ AUTOMAGIC_SERVER_HOST }/logo_previews`)
      err.status = 401
      return dispatch(_fetchLogoPreviewsFailure(err))
    }

    let preferences =  {
      selectedValues: props.userPrefs.selectedValues,
      selectedEmotions: props.userPrefs.selectedEmotions,
      selectedKeywords: props.userPrefs.selectedKeywords,
      selectedType: props.userPrefs.selectedType,
      selectedLanguage: props.userPrefs.selectedLanguage
    }

    if (preferences.selectedValues.length < 1 && props.availableValues) {
      preferences.selectedValues = props.availableValues.map(item => item.uid)
      props.userPrefs.updatedPrefs.values = true
    }
    if (preferences.selectedEmotions.length < 1 && props.availableEmotions) {
      preferences.selectedEmotions = props.availableEmotions.map(item => item.uid)
      props.userPrefs.updatedPrefs.emotions = true
    }

    // If didnt update name, values, emotions or colors do not fetch previews again
    if (props.availableLogoPreviews && props.userPrefs.updatedPrefs) {
      if (props.availableLogoPreviews.payload) {
        if(!props.userPrefs.updatedPrefs.name &&
           !props.userPrefs.updatedPrefs.values &&
           !props.userPrefs.updatedPrefs.emotions &&
           !props.userPrefs.updatedPrefs.type &&
           !props.userPrefs.updatedPrefs.keywords) {
          return dispatch(_fetchLogoPreviewsSuccess([]))
        }
      }
    }
    return fetch(`${ AUTOMAGIC_SERVER_HOST }/logo_previews`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userPreferences: preferences })
    })
    .then(response => {
      let { status } = response
      if (Number(status) === 401) {
        // Token is unauthorized, fail and store status to handle it later
        let err = new Error(`Unauthorized access on ${ AUTOMAGIC_SERVER_HOST }/logo_previews`)
        err.status = status
        return dispatch(_fetchLogoPreviewsFailure(err))
      }
      response.json().then(json => {
        return dispatch(_fetchLogoPreviewsSuccess(json))
      })
    })
    .catch(error => {
      dispatch(_fetchLogoPreviewsFailure(error))
    })
  }
}


export const performFreePurchase = (productID, logoToPurchase) => {
  return (dispatch) => {
    let jwtFromStorage = localStorage.getItem('automagic_token')
    let data = {
      productID: productID,
      purchasedLogo: JSON.stringify(logoToPurchase)
    }

    return fetch(`${ AUTOMAGIC_SERVER_HOST }/api/payments/demo`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(res => {
      return Promise.resolve(res)
    })
    .catch(error => {
      return Promise.reject(error)
    })
  }
}

export const UPDATE_LOGO_CANVAS = 'UPDATE_LOGO_CANVAS'
export const updateLogoCanvas = (data) => {
  return {
    type: UPDATE_LOGO_CANVAS,
    payload: data
  }
}

// Step 06: Logo Download

export const STEP_LOGO_DOWNLOAD = 'STEP_LOGO_DOWNLOAD'
export const stepLogoDownload = (formInfo) => {
  return {
    type: STEP_LOGO_DOWNLOAD,
    payload: formInfo
  }
}

// Selected language

export const UPDATE_SELECTED_LANGUAGE = 'UPDATE_SELECTED_LANGUAGE'
export const updateSelectedLanguage = (data) => {
  return {
    type: UPDATE_SELECTED_LANGUAGE,
    payload: data
  }
}

// Logo preview navigation

export const GET_NEXT_LOGO_PREVIEW = 'GET_NEXT_LOGO_PREVIEW'
export const getNextLogoPreview = () => {
  return {
    type: GET_NEXT_LOGO_PREVIEW
  }
}

export const GET_PREVIOUS_LOGO_PREVIEW = 'GET_PREVIOUS_LOGO_PREVIEW'
export const getPreviousLogoPreview = () => {
  return {
    type: GET_PREVIOUS_LOGO_PREVIEW
  }
}

// Keyboard handling

export const KEY_LEFT = 'KEY_LEFT'
export const KEY_RIGHT = 'KEY_RIGHT'



// WEBPACK FOOTER //
// ./src/actions/new-logo.js